var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3013_5510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.14 5.85573C26.3284 -1.95356 13.665 -1.95169 5.85573 5.86003C-1.95356 13.6717 -1.95169 26.335 5.86003 34.1443C13.6717 41.9536 26.335 41.9517 34.1443 34.14C37.8948 30.3884 40.0012 25.3005 40 19.9957C39.9989 14.6918 37.891 9.60558 34.14 5.85573ZM30.2893 27.8598C30.2885 27.8607 30.2876 27.8616 30.2867 27.8625V27.8558L29.2733 28.8624C27.9628 30.1896 26.0541 30.7356 24.24 30.3025C22.4122 29.8132 20.6747 29.0345 19.0933 27.9958C17.6241 27.0568 16.2625 25.9592 15.0333 24.7225C13.9023 23.5997 12.8862 22.3669 12 21.0424C11.0306 19.6173 10.2633 18.0648 9.71995 16.4291C9.09706 14.5075 9.61323 12.399 11.0533 10.9825L12.24 9.79581C12.5699 9.4644 13.106 9.46323 13.4373 9.79315C13.4382 9.79401 13.4391 9.79487 13.44 9.79581L17.1866 13.5425C17.518 13.8724 17.5192 14.4085 17.1892 14.7398C17.1884 14.7407 17.1875 14.7415 17.1866 14.7425L14.9866 16.9425C14.3553 17.5668 14.276 18.559 14.8 19.2758C15.5957 20.3678 16.4762 21.3954 17.4333 22.3492C18.5004 23.4209 19.6605 24.3958 20.9 25.2625C21.6161 25.7621 22.5871 25.6778 23.2066 25.0625L25.3332 22.9025C25.6632 22.5711 26.1992 22.57 26.5306 22.8999C26.5314 22.9007 26.5323 22.9016 26.5332 22.9025L30.2866 26.6625C30.6181 26.9924 30.6192 27.5284 30.2893 27.8598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3013_5510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.e6327184275828283eff0fbc8ec9b855.svg";
export { ForwardRef as ReactComponent };